export enum NavigationItemType {
  Unknown = 0,
  AppRoot = 2,
  Menu = 3,
  Page = 4,
  ClickThrough = 5
}
